
// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nProvider } from './i18n.jsx';
import { LoginBadge } from './components/LoginBadge';
import { ErrorBoundary } from './components/ErrorBoundary';
import { OfflineBanner } from './components/OfflineBanner';
import { CookieNotice } from './components/CookieNotice';
import './discord.css';
import { setupAudioUnlock } from './soundManager';

// Unlock audio on first user gesture and preload common SFX
setupAudioUnlock({ prefetch: ['/sfx/win.mp3'] });

// Filet global : les rejets de promesse non geres ne doivent pas passer silencieux.
window.addEventListener('unhandledrejection', (e) => console.error('[unhandledrejection]', e.reason));

// Mesure d'audience optionnelle (privacy-friendly, ex: Plausible), env-gated.
// Off par defaut. Pour l'activer : definir VITE_ANALYTICS_SRC + VITE_ANALYTICS_DOMAIN
// et autoriser le host dans la CSP nginx (script-src + connect-src).
if (import.meta.env.VITE_ANALYTICS_SRC && import.meta.env.VITE_ANALYTICS_DOMAIN) {
  const s = document.createElement('script');
  s.defer = true;
  s.src = import.meta.env.VITE_ANALYTICS_SRC;
  s.setAttribute('data-domain', import.meta.env.VITE_ANALYTICS_DOMAIN);
  document.head.appendChild(s);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <OfflineBanner />
        <App />
        <LoginBadge />
        <CookieNotice />
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>
);